import ComponentHelper from '../../supers/ComponentHelper';
import React from 'react';
import AceEditor from 'react-ace';

import 'brace/mode/json';
import 'brace/theme/github';
import 'brace/mode/sql';

class SmallJSONEditor extends ComponentHelper {
	onChange = newValue => {
		this.props.onChange(this.props.returnName, newValue);
	};
	render() {
		let { className, name, minLines, maxLines, value, onChange, returnName, mode = 'json', readOnly = false } = this.props;
		return (
			<AceEditor
				showPrintMargin={false}
				minLines={minLines ? minLines : 10}
				maxLines={maxLines ? maxLines : 20}
				className={`small-ace-editor shadow ${readOnly ? 'disabled' : ''} ${className}`}
				name={name}
				theme="github"
				mode={mode}
				fontSize={13}
				width="100%"
				value={value}
				onChange={returnName ? this.onChange : onChange}
				editorProps={{ $blockScrolling: Infinity }}
				readOnly={readOnly}
			/>
		);
	}
}

export default SmallJSONEditor;



// WEBPACK FOOTER //
// ./src/components/small-json-editor/SmallJSONEditor.js